import React from "react";
import { Routes, Route } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import Contact from "../pages/contact/Contact";
import Home from "../pages/home/Home";
import Membership from "../pages/membership/Membership";
import SpaceGuide from "../pages/spaceGuide/SpaceGuide";

const RoutesComponent = () => {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        {/* 홈 */}
        <Route path="/" element={<Home />} />
        {/* 공간안내 */}
        <Route path="/spaceguide" element={<SpaceGuide />} />
        {/* 멤버쉽 */}
        <Route path="/membership" element={<Membership />} />
        {/* 방문예약 */}
        <Route path="/contact" element={<Contact />} />
      </Route>
    </Routes>
  );
};

export default RoutesComponent;
